import { render, staticRenderFns } from "./IconDuplicate.vue?vue&type=template&id=7ef5900e&"
import script from "./IconDuplicate.vue?vue&type=script&lang=js&"
export * from "./IconDuplicate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports